export default __webpack_public_path__ + "static/media/flag-georgia.0b2c3544.svg";